import InfoTooltip from '../InfoTooltip/InfoTooltip.vue';

export default {
  props: {
    content: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
    },
  },

  components: {
    InfoTooltip,
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.html.querySelector('h3')) {
        this.teleport = this.$refs.html.querySelector('h3');
      }
      this.isReady = true;
    });
  },

  data() {
    return {
      isReady: false,
      teleport: null,
    };
  },

  computed: {},

  methods: {},

  watch: {},
};
